import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";
import {
  addNewsBannerApi,
  deleteNewsBannerApi,
  getNewsBannerApi,
  updateNewsBannerApi,
} from "../../helpers/api/news";
import {
  getNewsBanner,
  NewsBannerApiResponseError,
  NewsBannerApiResponseSuccess,
} from "./actions";
import { NewsBnrActionTypes } from "./constants";

interface NewsBannerData {
  payload: {
    id: number;
    file: any;
    banner_text: string;
    banner_text_ar: string;
  };
  type: string;
}

function* createNewsBanner({
  payload: { file, banner_text, banner_text_ar },
}: NewsBannerData): SagaIterator {
  try {
    const response = yield call(addNewsBannerApi, {
      file,
      banner_text,
      banner_text_ar,
    });

    const mainBannerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      NewsBannerApiResponseSuccess(
        NewsBnrActionTypes.CREATE_NEWS_IMAGE,
        mainBannerData
      )
    );
    yield put(getNewsBanner());
  } catch (error: any) {
    yield put(
      NewsBannerApiResponseError(NewsBnrActionTypes.CREATE_NEWS_IMAGE, error)
    );
  }
}

function* updateNewsBanner({
  payload: { id, banner_text, banner_text_ar, file },
}: NewsBannerData): SagaIterator {
  try {
    const response = yield call(updateNewsBannerApi, id, {
      file,
      banner_text,
      banner_text_ar,
    });
    const mainBannerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      NewsBannerApiResponseSuccess(
        NewsBnrActionTypes.UPDATE_NEWS_IMAGE,
        mainBannerData
      )
    );
    yield put(getNewsBanner());
  } catch (error: any) {
    yield put(
      NewsBannerApiResponseError(NewsBnrActionTypes.UPDATE_NEWS_IMAGE, error)
    );
  }
}

function* getNewsBanners(): SagaIterator {
  try {
    const response = yield call(getNewsBannerApi);

    const NewsBannerData = response?.data?.data;

    yield put(
      NewsBannerApiResponseSuccess(
        NewsBnrActionTypes.GET_NEWS_IMAGE,
        NewsBannerData
      )
    );
  } catch (error: any) {
    yield put(
      NewsBannerApiResponseError(NewsBnrActionTypes.GET_NEWS_IMAGE, error)
    );
  }
}

function* deleteNewsBanner({ payload: { id } }: NewsBannerData): SagaIterator {
  try {
    const response = yield call(deleteNewsBannerApi, id);
    const mainBannerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      NewsBannerApiResponseSuccess(
        NewsBnrActionTypes.DELETE_NEWS_IMAGE,
        mainBannerData
      )
    );
    yield put(getNewsBanner());
  } catch (error: any) {
    yield put(
      NewsBannerApiResponseError(NewsBnrActionTypes.DELETE_NEWS_IMAGE, error)
    );
  }
}

export function* watchCreateNewsBanner() {
  yield takeEvery(NewsBnrActionTypes.CREATE_NEWS_IMAGE, createNewsBanner);
}
export function* watchUpdateNewsBanner() {
  yield takeEvery(NewsBnrActionTypes.UPDATE_NEWS_IMAGE, updateNewsBanner);
}
export function* watchGetNewsBanner() {
  yield takeEvery(NewsBnrActionTypes.GET_NEWS_IMAGE, getNewsBanners);
}

export function* watchDeleteNewsBanner() {
  yield takeEvery(NewsBnrActionTypes.DELETE_NEWS_IMAGE, deleteNewsBanner);
}

function* NewsBannerSaga() {
  yield all([
    fork(watchCreateNewsBanner),
    fork(watchUpdateNewsBanner),
    fork(watchDeleteNewsBanner),
    fork(watchGetNewsBanner),
  ]);
}

export default NewsBannerSaga;
